import React from "react";
import "./style.css";
import ClaudeLogo from "../Brand/Logo";
import { HeaderInterface } from "./types";

const Header: React.FC<HeaderInterface> = ({ mainTitle }) => {
  return (
    <header className="app-header">
      <div className="app-header__inner">
        <a className="app-brand" href="/">
          <span className="app-brand__mark">
            <ClaudeLogo size={20} />
          </span>
          <span className="app-brand__name">{mainTitle}</span>
        </a>
      </div>
    </header>
  );
};

export default Header;
